import {
  Component,
  inject,
  OnInit,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { LanguageService } from '../../Services/language.service';
import { CategoryService } from '../../Services/category.service';
import { getAllCategories } from '../../models/Categories Requests DTO/get-categroies.model';
import { CategoriesScrollerComponent } from '../../userComponents/categories-scroller/categories-scroller.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-categories',
  templateUrl: './page-categories.component.html',
  styleUrl: './page-categories.component.scss',
})
export class PageCategoriesComponent implements OnInit {
  languageService = inject(LanguageService);
  private categoryService = inject(CategoryService);
  @ViewChild(CategoriesScrollerComponent) categoryScroller!: CategoriesScrollerComponent;
  MenuTitle: WritableSignal<string> = signal('');
  NavLeft: WritableSignal<string> = signal('');
  NavRight: WritableSignal<string> = signal('');
  categories?: getAllCategories[];
  language = this.languageService.getLanguage();


  ngOnInit(): void {
    // Subscribe to language changes to update titles reactively
    this.languageService.currentLanguage$.subscribe(() => {
      this.updateTitles();
    });

    this.categoryService.getAllCategories().subscribe({
      next: (response) => {
        this.categories = response;
        this.categories?.sort((a, b) => a.ordernumber - b.ordernumber);
      }
    });

    // Initialize titles based on the default language
    this.updateTitles();
  }
  
     private updateTitles() {
    // Update titles based on the current language in the service
    this.MenuTitle = this.languageService.MenuPageTitle;
    this.NavLeft = this.languageService.Home;
    this.NavRight = this.languageService.Cart;

  }

  onCategoryClicked(categoryIdClicked: number): void {
   // console.log('Category clicked:', categoryIdClicked);
  
    // Update the scrolle
    // Update the menu items to match the selected category
    this.updateMenuItems(categoryIdClicked);
  }
  
  updateMenuItems(categoryId: number): void {
    // Implement the logic to fetch and update menu items for the selected category
    this.categoryService.getSingleCategory(categoryId).subscribe({
      next: (category) => {
        //console.log('Menu items updated for category:', category);
        // Perform any additional updates for the menu UI here
      },
      error: (err) => {
        console.error('Error fetching category for menu items:', err);
      },
    });
  }
}
